import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToRevisionedPlatformAssistantConfiguration,
  mapApiResourceToWorkspaceAssistantConfiguration,
  mapPlatformAssistantConfigurationToApiResource,
  mapWorkspaceAssistantOverrideToApiResource,
  mapWorkspaceOwnerUpdateToApiResource,
} from './assistantConfigurationMapping';
import type {
  PlatformAssistantConfiguration,
  PlatformAssistantConfigurationApiResource,
  RevisionedPlatformAssistantConfiguration,
  RevisionedSave,
  WorkspaceAssistantConfiguration,
  WorkspaceAssistantConfigurationApiResource,
  WorkspaceAssistantOverride,
  WorkspaceOwnerAssistantConfigurationUpdate,
} from './assistantConfigurationApi.types';

const PLATFORM_CONFIGURATION_PATH = '/assistant/configuration/platform';
const WORKSPACE_CONFIGURATION_PATH = '/assistant/configuration/workspace';

function buildTenantConfigurationPath(tenantId: string): string {
  return '/tenants/' + tenantId + '/assistant-configuration';
}

export async function fetchPlatformAssistantConfiguration(): Promise<RevisionedPlatformAssistantConfiguration> {
  const response = await httpClient.get<PlatformAssistantConfigurationApiResource>(
    PLATFORM_CONFIGURATION_PATH
  );
  return mapApiResourceToRevisionedPlatformAssistantConfiguration(response.data);
}

export async function savePlatformAssistantConfiguration(
  save: RevisionedSave<PlatformAssistantConfiguration>
): Promise<RevisionedPlatformAssistantConfiguration> {
  const response = await httpClient.put<PlatformAssistantConfigurationApiResource>(
    PLATFORM_CONFIGURATION_PATH,
    mapPlatformAssistantConfigurationToApiResource(save)
  );
  return mapApiResourceToRevisionedPlatformAssistantConfiguration(response.data);
}

export async function fetchTenantAssistantConfiguration(
  tenantId: string
): Promise<WorkspaceAssistantConfiguration> {
  const response = await httpClient.get<WorkspaceAssistantConfigurationApiResource>(
    buildTenantConfigurationPath(tenantId)
  );
  return mapApiResourceToWorkspaceAssistantConfiguration(response.data);
}

export async function saveTenantAssistantConfiguration(
  tenantId: string,
  save: RevisionedSave<WorkspaceAssistantOverride>
): Promise<WorkspaceAssistantConfiguration> {
  const response = await httpClient.put<WorkspaceAssistantConfigurationApiResource>(
    buildTenantConfigurationPath(tenantId),
    mapWorkspaceAssistantOverrideToApiResource(save)
  );
  return mapApiResourceToWorkspaceAssistantConfiguration(response.data);
}

export async function fetchWorkspaceAssistantConfiguration(): Promise<WorkspaceAssistantConfiguration> {
  const response = await httpClient.get<WorkspaceAssistantConfigurationApiResource>(
    WORKSPACE_CONFIGURATION_PATH
  );
  return mapApiResourceToWorkspaceAssistantConfiguration(response.data);
}

export async function saveWorkspaceAssistantConfiguration(
  save: RevisionedSave<WorkspaceOwnerAssistantConfigurationUpdate>
): Promise<WorkspaceAssistantConfiguration> {
  const response = await httpClient.put<WorkspaceAssistantConfigurationApiResource>(
    WORKSPACE_CONFIGURATION_PATH,
    mapWorkspaceOwnerUpdateToApiResource(save)
  );
  return mapApiResourceToWorkspaceAssistantConfiguration(response.data);
}
